import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { API_DOMAIN, API_AUTH_TOKEN, CLIENT_ID_SESSION_API } from '../../EnvVars';
import axios from 'axios';

import FourOFourContainer from './FourOFourContainer';
import Api from '../../api/api';

class AppRedirectToOSB extends Component {
  constructor(props) {
    super(props);
    this.dealerCode = null;
    this.locationCode = null;
    this.bookingId = null;
    this.email = null;
    this.state = {
      redirectURL: null,
      loading: true,
      four0Four: false,
    };
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    this.dealerCode = queryParams.get('dealerCode');
    this.email = queryParams.get('email');
    this.locationCode = queryParams.get('locationCode'); // 1234
    this.bookingId = queryParams.get('bookingId');

    try {
      let authToken = await axios.post(
        `${API_AUTH_TOKEN}`,
        {},
        { headers: { client_id: CLIENT_ID_SESSION_API } },
      );

      const token = await authToken.data;
      if (token.access_token) {
        const newToken = token.token_type + ' ' + token.access_token;
        this.postRedirect(newToken);
      } else {
        this.postRedirect(token);
      }
    } catch (error) {
      this.setState({
        loading: false,
        four0four: true,
      });
    }
  }

  /**
   * @description finds the booking info based on the query params from the url
   * will redirect to OSB if the booking is found, or show the 404 error page
   * @async
   */
  postRedirect = async token => {
    const findBookingURL = API_DOMAIN + '/api/bookingep/deeplink/dms/booking';
    const deeplinkUrlStr = 'deeplink-';
    const config = {
      headers: {
        Accept: 'application/json',
        Authorization: token,
      },
      params: {
        dealerCode: this.dealerCode,
        locationCode: this.locationCode,
        bookingId: this.bookingId,
        email: this.email,
      },
    };

    try {
      const params = {
        dealerCode: this.dealerCode,
        locationCode: this.locationCode,
        bookingId: this.bookingId,
        email: this.email,
      };
      const bookingData = await Api.getBookingUrl(params);
      const bookingUrl = bookingData.dealerUrl + '/' + deeplinkUrlStr + bookingData.booking.uuid;
      window.location.replace(bookingUrl);
    } catch (error) {
      this.setState({
        loading: false,
        four0four: true,
      });
    }
  };

  render() {
    const showSpinner = (
      <div>
        <img alt="loading" className="spanner" src="./images/spanner.gif" />
      </div>
    );

    return (
      <div>
        {this.state.loading && showSpinner}
        {!this.state.loading && <FourOFourContainer />}
      </div>
    );
  }
}
export default withRouter(AppRedirectToOSB);



// WEBPACK FOOTER //
// ./src/containers/Redirect/AppRedirectToOSB.js